var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,39.9c-0.5,0.1-1.1,0.7-1.7,0.7c-0.6,0-0.7-0.6-1.8-0.6c-0.7,0-6.4,3-9.8,2.9c-2.4-0.1-3.6-1-3.6-1 s0.1,0.7,1.4,1.1c0.8,0.2,2.5,0.6,5.2,0.7c2,0,3.8,1,7.8,1s6.4-2.1,6.8-2.4c0.4-0.3,1.2-0.7,1.8-1c0.5-0.3,0.6-0.6,0.6-0.6 s-0.6,0.2-2.1,0.3C48,41.2,45.5,39.8,45,39.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.4,28.4c-3.9-0.1-4.9,2.4-4.9,3.2c0,0.2,0,0.7,0,0.7l0.9-0.1c0-0.2,0-0.5,0-0.6c0-0.6,0.8-2.4,4-2.3 c3.5,0.1,3.7,3.1,3.7,3.2c0,0.6-0.4,1.4-0.4,1.4l0.4,0.2l0.4,0.2c0,0,0.5-1,0.4-1.8C37,31.4,36,28.5,32.4,28.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.7,28.3C48.7,28.3,48.6,28.3,48.7,28.3c-1.9,0-2.9,0.8-3.4,1.5c-1,1.3-0.9,2.9-0.6,4l0.9-0.3 c-0.2-0.8-0.3-2.2,0.5-3.1c0.6-0.7,1.4-1.1,2.6-1.1c0,0,0,0,0,0c1.1,0,1.9,0.4,2.4,1c0.4,0.6,0.5,1.3,0.4,1.7l0.9,0.3 c0.2-0.6,0.1-1.6-0.5-2.5C51.3,29.1,50.4,28.3,48.7,28.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.2,30.1c-1.7,0-2.2,1.7-2.2,1.8c0,0.1,0,0.5,0,0.5s1.2,0.1,2.4,0.4c1.3,0.3,2,0.8,2,0.8s0.4-0.5,0.3-1 S34.5,30.1,32.2,30.1z M31.6,31.4c-0.2,0.2-0.4,0.2-0.6,0.1c-0.2-0.2-0.2-0.4-0.1-0.6s0.4-0.2,0.6-0.1 C31.7,30.9,31.8,31.2,31.6,31.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.1,29.9c-2,0-2.2,1.6-2.2,2.1c0,0.5,0.3,1.1,0.3,1.1s1-0.3,2-0.6c0.9-0.3,2-0.4,2-0.4S50.6,30,48.1,29.9z  M47.4,31.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5C47.8,31.3,47.6,31.5,47.4,31.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.2,22.9c-9.3,0-12.9,7.5-12.5,7.8c0.4,0.3,0.9,0.2,2.8-1.8c1.2-1.3,4.9-3.5,9.2-3.5s6.9,2.7,6.9,2.7 s0.3-0.8,0.5-1.5c0.2-0.7,0.2-2,0.2-2S37.9,22.9,32.2,22.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55.2,17c-1.8-1.6-5.2-4.3-8.2-5.7c-3-1.4-7.1-3.5-8-3.5c-1,0-10.5,3.2-14.4,5.4C22,14.8,15.7,19.3,11.2,25 c-1.8,2.3-3,4.5-2.7,6.5c0.3,1.9,2,5.4,3.1,7c0.8,1.3,1.8,2,2.5,2.1c-0.2,0.7-0.6,1.2-1.1,1.7c-0.8,0.9-1.6,1.9-1.4,3.8 c0,0.3,0.1,0.6,0.2,0.9c-0.3,0.4-0.6,0.9-0.6,1.6c0,1.9,1.6,2.6,2.5,2.6c0.9,0,2.2-0.6,2.2-2.5c0.2-0.1,0.4-0.2,0.6-0.4 c0.2,0.6,0.6,1.3,1,2.1c1.5,2.6,3.9,4.4,7.3,5.5c0.1,0.1,0.2,0.2,0.2,0.2s0.1,0,0.2,0c0.4,0.1,0.9,0.2,1.3,0.4c0.1,0,0.2,0,0.3,0.1 c0.3,0.2,0.6,0.4,0.6,0.4l0-0.3c0.2,0,0.5,0,0.8,0l1.1,0.6l0.1-0.6c0.2,0,0.4,0,0.6,0c0.3,0.1,0.6,0.3,0.8,0.4 c0.8,0.3,1.9,0.4,3.3,1.1c1.5,0.8,1.9,2.3,3.2,3.5c1.3,1.2,5.1,1.6,6.4,2.6c0.5,0.4,1,1.8,1,1.8s0.6-1.8,0.6-2.8 c0-1.1-1.6-2.9-1.6-3.4c0-0.4,0.6-1.7,1.1-2c0.5-0.3,1.6-0.2,1.6-0.2s0.8-1.1,1.1-1.2c0.3-0.1,0.6,0,0.6,0l0.5-1l0.3,0.4 c0,0,0.4-0.2,0.6-0.6c0.2-0.3,0.6-0.9,0.9-1.3c0.3-0.1,0.6-0.3,0.8-0.4c3-1.8,5.2-6.2,6.1-12c0.6-4.4-1.8-7.3-3-8.4 c1.2-1.1,3.2-3.7,3.5-7.9C58.4,19.8,57.8,19.3,55.2,17z M13.8,50.3c-1,0-1.7-0.7-1.7-1.6c0-0.3,0.1-0.5,0.2-0.7 c0.5,0.6,1.1,1.1,2.1,1.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0C15,49.5,14.6,50.3,13.8,50.3z M16.8,38.4c0,0.1,0,0.2,0,0.3 c-0.1,1.2-0.4,2.1-0.6,2.8c-0.1,0.5-0.2,0.9-0.3,1.3l0,0.1c-0.1,0.8-0.3,2.1,0.1,3.9c-0.2,0.3-0.8,0.9-1.5,0.8 c-0.6-0.1-1-0.4-1.2-0.8c0.1,0,0.2,0,0.2,0c0.5,0,0.7,0,0.7-0.2c0-0.5-0.6-0.5-0.9-0.5c-0.1,0-0.2,0-0.3,0.1c0-0.1,0-0.1,0-0.2 c-0.1-1.3,0.4-2,1.1-2.8c0.7-0.8,1.5-1.8,1.5-3.4c0-1.4-0.7-3.1-1.4-4.6c-0.4-0.9-0.8-1.8-0.9-2.4c-0.2-1,0-1.9,0.6-2.5 c0.5-0.5,1.1-0.8,1.8-0.7c0.4,0,0.9,0.3,1.1,0.5c-0.1,0.5-0.1,0.9-0.1,1.4c-0.1-0.1-0.3-0.1-0.5-0.1c-0.7,0.1-1.5,0.2-1.4,1.9 C14.9,35.2,16.8,37.8,16.8,38.4z M52.5,45.8c0,0-0.2,0.7-0.6,1.4c-0.5,0.7-1,1.5-4,1.8c-3,0.3-5.5-1.2-5.5-1.2s-3.6,1.9-4.9,2.4 c-1.3,0.5-4.2,0.4-4.2,0.4l0.3-0.7c0,0-2.5,0.7-3.7,0.4c-1.1-0.3-5.4-2.5-5.5-6.7c-0.2-4.2,3.9-6.3,3.9-6.3V38c0,0,0.3,0,0.8-0.3 c0.5-0.3,1.7-0.6,1.7-0.6l-0.4,1.3c0,0,4.5-1.9,5.8-1.9c0.8,0,1.8,0.1,2.4,0.2c0.2,0.2,0.5,0.3,0.8,0.3c0.6,0.1,1.1-0.1,1.1-0.1 s0.4,0.8,2.4,0.8c1,0,1.6-0.6,1.9-0.9c0.5-0.2,1.9-0.7,3.8-0.7c3.2-0.1,3.7,2.9,3.8,3.9c0.1,1-0.4,2.8-0.4,2.8l0.6-0.3 c0,0,0.1,0.6-0.1,1.4c-0.2,0.7-0.7,2.2-0.7,2.2L52.5,45.8z M56.1,41.2c-0.6,3.9-1.8,7.1-3.4,9.2c0.6-1.6,1.4-3.9,1.7-4.4 c0.5-0.7,0.5-0.4,0.5-0.4s0.2-4.3,0.2-5.2c0-1.8-1.2-3.3-1.2-3.3l0.9,0c0,0-1.7-3.1-4.9-3.3c-1.5-0.1-2.8,0.6-3.7,1.3 c0.1-0.4-0.1-0.8-0.2-1c-0.2-0.4-0.7-0.8-0.9-0.7c-0.2,0.2,0.5,0.3,0.5,0.9c0,0.7-0.5,0.6-0.5,0.6s0,0-0.2-0.5 c-0.2-0.4-0.9-0.9-1.1-0.7c-0.2,0.2,0.5,0.8,0.5,1.2c0.1,0.5,0.4,1.2-1.6,1.4c-2.4,0.2-1.4-2.1-1.8-2.2c-0.4-0.1-0.6,0.6-0.7,1.2 C40.2,36,40.2,36,40.2,36s-0.7,0.4-1.3-0.4c-0.4-0.5,0-1.2-0.2-1.3c-0.2-0.1-0.7,0.6-0.6,1.5c0,0.3,0.1,0.5,0.3,0.7 c-1.4-0.5-4.2-1.6-6-1.8c-2.5-0.3-4.6,0-8.3,2.3c-3.7,2.2-3.9,8.1-2.9,12.5c0.4,1.7,1,3,1.7,4.1c-1.8-0.9-3.1-2.2-4-3.8 c-1.9-3.3-1.6-5.4-1.4-6.6l0-0.1c0-0.3,0.2-0.7,0.3-1.2c0.3-1.2,0.8-2.9,0.8-5.4c0-0.5-0.1-1.2-0.1-1.9c-0.1-1.9-0.3-4.5,0.5-5.5 c0.1-0.1,0.3-0.3,0.4-0.6c1.8-2.4,7.3-9.9,21.6-9.4c5.5,0.2,9.3,1.5,11.3,3.8c0.6,0.7,0.9,1.4,1.2,2.1c-0.2-0.3-0.5-0.6-0.8-0.8 c-0.4-0.3-1.4-1.2-4.2-1.3c-3.3-0.1-4.7,1.8-4.7,1.8s0,0.6,0.1,1.4c0.1,0.8,0.5,1.7,0.5,1.7c1.3-0.4,1.2-3,5-3 c2.6,0,3.9,1.3,4.4,2.1c0.1,1.1,0,2.1-0.1,2.9c-0.1,1.1-0.7,2.8-0.7,2.8l-0.2,0.5l0.4,0.3C53.2,33.6,56.8,36.4,56.1,41.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.5,12.2c2.2-1.3,9.8-4.2,9.8-4.2s-0.6-0.3-6.8,0.2c-4.6,0.4-7.9,1-12.3,2.2c-1.9,0.5-3.2,1.6-3.6,2.5 c-0.5,1-2.5,5.9-2.8,9c-0.3,3.1,0.5,4.4,0.5,4.4s2.2-3.2,4.7-5.7C15.2,18.7,19.9,14.3,23.5,12.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.3,8c0,0,6.4,2.7,9.4,5.1c3,2.4,5.1,4.5,5.1,4.5s0.3-1.1,0-2.7c-0.3-1.6-1.7-5.2-2.3-6 c-0.6-0.8-1.5-1.2-3.8-1.3C48.5,7.4,43.3,8,43.3,8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 43.0157,
    cy: 5.6431,
    r: 61.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    style: {
      stopColor: "#79A406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#609418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    style: {
      stopColor: "#397A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#106050"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.2,6.5C34,6.5,36.3,7,36.3,7s1.9-0.6,2.6-0.7c0.6,0,1.7,0.5,1.7,0.5s3.8-0.4,5.8-0.5c2-0.1,4.7-0.2,4.7-0.2 s-3.8-3.3-6.3-4.3c-2.5-1.1-4.7-1.9-7.3-1.8C35,0.1,29.8,0.6,25.4,1.7S18.2,4,17.4,4.8c-0.8,0.8-2.2,2.6-2.6,3.2 c-0.3,0.6-0.6,1.1-0.6,1.1s2.5-0.8,5.7-1.3C23.1,7.2,28.3,6.6,31.2,6.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.557d16eb8dfb42521499851713dd39db.svg";
export { ForwardRef as ReactComponent };